import React, { Component } from 'react';
import 'react-bootstrap';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import NotificationSystem from 'react-notification-system';
import $ from "jquery/dist/jquery.js";

import { routes } from "./config/routes";
import store from './store/configureStore';
import Root from './views/Root';
import Header from './components/Header';
import TopBanner from "./components/TopBanner";
import Footer from './components/Footer';
import NotFound from './views/notFound/NotFound';
import envApi from "./api/envApi";
import { addNotification, resetNotification } from "./actions/notificationAction";
import { changeLanguageAction } from './actions/langAction';
import { lang } from './config/lang';
import activityApi from './api/activityApi';
import { setSideActivityAction } from './actions/activityAction';

/****************************************
    RootComponent
    @author  IMH003
    @date    2019.5.24
    @version 0.1    
 ******************************************/

class App extends Component {

    constructor(props) {
        super(props);

        this.state = {
            lang: 'en'
        };
        this.getEnvironment = this.getEnvironment.bind(this);
        this.getKeywords = this.getKeywords.bind(this);
        const { location } = props.history;

        // if (location.pathname.indexOf('/activity') != -1) {
        //     activityApi.getAll(0).then((json) => {
        //         if (json.status === 200 && json.data) {
        //             store.dispatch(setSideActivityAction(json.data.slice(0, 5)));
        //             console.log(store.getState().activity)
        //         } else {
        //             if (json.status === 620) {
        //                 store.dispatch(addNotification(`${lang('access_deny')}`, 'error'));
        //             } else {

        //             }
        //         }
        //     })
        // }
    }

    componentWillMount() {
        this.getEnvironment();
        this.getKeywords();

    }

    componentDidMount() {
        this.notificationSystem = this.refs.notificationSystem;
    }

    componentWillUnmount() {
    }

    componentWillReceiveProps(newProps) {
        const { message, level } = newProps.notification;

        if (message && this.notificationSystem) {
            this.notificationSystem.addNotification({
                title: (
                    <span data-notify="icon" className="pe-7s-speaker"></span>
                ), message, level, position: "tr", autoDismiss: 3
            });
            this.props.actions.resetNotification()
        }
    }

    updateKeywords(keywords) {
        if (keywords !== undefined && keywords !== null && keywords !== "") {
            $('meta[name="keywords"]').attr('content', keywords);
        } else {

        }
    }

    updateEnvironment(env) {
        var themes = [
            'blue',
            'red',
            'olive',
            'orange',
            'yellow',
            'green',
            'teal',
            'violet',
            'purple',
            'pink',
            'brown',
            'grey',
            'black',
        ];
        var customCSS = document.createElement("link");
        customCSS.type = "text/css";
        customCSS.rel = "stylesheet";
        customCSS.href = "/assets/css/custom/" + themes[env.theme] + ".css";
        customCSS.id = "custom_css";
        $("link").remove("#custom_css");
        $('head').append(customCSS);
        localStorage.setItem('theme', themes[env.theme]);

        var cur_lang = localStorage.getItem('language');
        if (cur_lang == undefined || cur_lang == null) {
            localStorage.setItem('language', env.main_lang);
            this.state.lang = env.main_lang;
            store.dispatch(changeLanguageAction(env.main_lang));
        } else {
            // store.dispatch(changeLanguageAction(env.main_lang));
        }

        // $('title').text(lang('title'));
    }

    getEnvironment() {
        envApi.getEnvironment().then((json) => {
            if (json.status === 200 && json.data) {
                this.updateEnvironment(json.data);
            } else {

            }
        })
    }

    getKeywords() {
        envApi.getKeywords().then((json) => {
            if (json.status === 200) {
                this.updateKeywords(json.data);
            } else {

            }
        })
    }

    render() {
        return (
            <div className="app-main">
                <div>
                    <NotificationSystem ref="notificationSystem" />
                </div>

                <Header />

                <TopBanner />
                <Switch>
                    <Route exact path="/" component={Root} />
                    {
                        routes.map((prop, key) => {
                            return (<Route path={prop.path} component={Root} key={key} />)
                        })
                    }
                    <Route path="*" component={NotFound} status={404} />
                </Switch>

                <Footer />

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        notification: state.notification,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            addNotification,
            resetNotification,
        }, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);


